"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AtmFilled = function AtmFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22 2.75v5.5a.751.751 0 01-.75.75H18V5.125A1.127 1.127 0 0016.875 4h-9.75A1.127 1.127 0 006 5.125V9H2.75A.751.751 0 012 8.25v-5.5A.751.751 0 012.75 2h18.5a.751.751 0 01.75.75zm-5 2.375v15.948a.93.93 0 01-.927.927H7.927A.93.93 0 017 21.073V5.125A.125.125 0 017.125 5h9.75a.125.125 0 01.125.125zM11 9a1 1 0 101-1 1 1 0 00-1 1zm2 9a1 1 0 10-1 1 1 1 0 001-1zm3-4.5a.5.5 0 00-.5-.5h-.636a1.986 1.986 0 00-.074-.318 1.746 1.746 0 00-1.7-1.082c-1.1 0-1.506.916-1.8 1.585-.287.65-.428.867-.692.867a.559.559 0 01-.5-.365.788.788 0 01.227-.885.5.5 0 10-.711-.7 1.943 1.943 0 00-.512.9H8.5a.5.5 0 000 1h.664c.009.024.008.048.018.072a1.55 1.55 0 001.418.98c.961 0 1.334-.845 1.607-1.463.3-.688.48-.989.887-.989a.759.759 0 01.773.467 1.441 1.441 0 01-.332 1.481.5.5 0 00.711.7A2.469 2.469 0 0014.9 14h.6a.5.5 0 00.5-.5z",
    fill: "currentColor"
  })));
};

var _default = AtmFilled;
exports["default"] = _default;